module.exports = __webpack_public_path__ + "png/friends-icon.png?28caa281b93dfb6287daad6659fd9ca2";